import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    enableActiveWrapper: false,
};

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState,
    reducers: {
        setSidebarData: (state, action) => {
            state.enableActiveWrapper = action.payload.enableActiveWrapper;
        },
    },
});

export const { setSidebarData } = sidebarSlice.actions;

export default sidebarSlice.reducer;
